import Controller from "./editableTime.controller";
import template from "./editableTime.html";

const editableTime = {
  template,
  controller: Controller,
  bindings: {
    selected: "=",
    title: "@",
    name: "@",
    eventName: "<",
    index: "<",
    hideEdit: "<",
    permissionName: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    extraParams: "<",
    isDisabled: "<",
    showIcon: "<",
    editInput: "<",
  },
};

export default editableTime;



// WEBPACK FOOTER //
// ./src/components/editableTime/editableTime.component.js